import React from 'react'
import './user.css'


function User({user}) {
    return (
        <div className="user">
            {user.username}
        </div>
    )
}

export default User
